var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AtividadesComponent',{attrs:{"tkn":_vm.token}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }